import { render, staticRenderFns } from "./CreditReportsTable.vue?vue&type=template&id=99efc962"
import script from "./CreditReportsTable.vue?vue&type=script&lang=js"
export * from "./CreditReportsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports